<app-badge>
  <mat-icon class="material-icons-outlined">monetization_on</mat-icon>
  <span>{{ datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.currency }}</span>
</app-badge>
